$(function() {

    $('select[name="account_tenant"]').on('change', function() {
        $('select[name="xero_theme_id"] option[data-for]').hide();
        let val = $(this).val();
        if (val !== '') {
            $(`select[name="xero_theme_id"] option[data-for="${val}"]`).show();
        }
    }).trigger('change');
});